export default __webpack_public_path__ + "static/media/Sequence 11.904cfaf3.mp4";